import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress console output in production
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  // Keep console.error for critical issues
}

// Global error handler to suppress DOMException clone errors
window.addEventListener('error', (event) => {
  if (event.error && event.error instanceof DOMException && 
      (event.error.name === 'DataCloneError' || 
       event.error.message?.includes('clone') ||
       event.error.message?.includes('cloned'))) {
    event.preventDefault();
    event.stopPropagation();
    console.log('Suppressed DataCloneError');
    return false;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && 
      (event.reason.message?.includes('clone') || 
       event.reason.message?.includes('cloned') ||
       event.reason.name === 'DataCloneError')) {
    event.preventDefault();
    console.log('Suppressed unhandled DataCloneError rejection');
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

